import { getIsStateRequiredByUuid } from "utils/stateRequired";
import { array, object, string } from "yup";

export const groupDetails = object({
  leadfounder_first_name: string()
    .min(1, "Min. 1 character")
    .required("Required"),
  leadfounder_last_name: string()
    .min(1, "Min. 1 character")
    .required("Required"),
  leadfounder_email: string()
    .email("Should be a valid email")
    .required("Email is required"),
  leadfounder_linkedin: string().notRequired().url("Should be a valid URL"),
  group_name: string().min(3, "Min. 3 characters").required("Required"),
  users_data: array().of(
    object({
      first_name: string().min(1, "Min. 1 character").required("Required"),
      last_name: string().min(1, "Min. 1 character").required("Required"),
      email: string().email("Should be a valid email").required("Required"),
      linkedin: string().notRequired().url("Should be a valid URL"),
    })
  ),
});

export const entityDetails = (countries = []) =>
  object({
    company_name: string().min(3, "Min. 3 characters").required("Required"),
    country: string().required("Required"),
    state_id: string().when("country", {
      is: (countryId) => getIsStateRequiredByUuid(countries, countryId),
      then: string().required("Required"),
      otherwise: string().notRequired(),
    }),
    formation_type_id: string().required("Required"),
  });

export const emailDetail = object({
  referrer_email: string().required("Please select a referrer"),
});
